// Shown when GET /api/bi/dashboards (the boot probe) returns 401 (not signed
// in) or 403 (signed in, but off the employee domain list or without a
// `bi_site` grant, `web/deps/identity.py`). BI signs in with its OWN Google
// OAuth (`web/routes/bi_auth.py`): `/api/bi/auth/google/begin` and a DISTINCT
// cookie (`bi_authority`), so a BI session never grants admin-console access
// or vice versa.
import { Button } from "@bi/shared";

import { BI_API_BASE } from "../config";
import { clearSignedOut } from "../lib/identity";
import { rememberReturnTo } from "../lib/return-to";

function signInWithGoogle() {
  clearSignedOut();
  // Remember where we are before leaving for Google — the callback can only
  // redirect to the BI app root (a client-side route never reaches the
  // backend). main.tsx puts the path back on the way in (lib/return-to.ts).
  rememberReturnTo(window.location);
  window.location.href = `${BI_API_BASE}/api/bi/auth/google/begin`;
}

function retry() {
  clearSignedOut();
  window.location.reload();
}

export function SignInPanel({ forbidden = false }: { forbidden?: boolean }) {
  return (
    <div className="bi-signin">
      <div className="bi-signin__card">
        <div className="bi-signin__wordmark">
          <span className="bi-signin__mark" aria-hidden="true">
            M
          </span>
          <h1 className="bi-signin__title">
            Mira BI
            <span className="bi-signin__title-sub">Dashboards</span>
          </h1>
        </div>
        {forbidden ? (
          <p className="bi-signin__body">
            You're signed in with Google, but this account isn't authorized for BI. Sign in with an
            account on the allowed domain for this environment.
          </p>
        ) : (
          <p className="bi-signin__body">Sign in with your Fiverr Google account to continue.</p>
        )}
        <div className="bi-signin__actions">
          {!forbidden ? (
            <Button variant="solid" tone="accent" onClick={signInWithGoogle}>
              Sign in with Google
            </Button>
          ) : null}
          <Button variant="outline" tone="neutral" onClick={retry}>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
}
